import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

type MarketKycDocvState = {
  submittedForUserId: string | null;
};

type MarketKycDocvActions = {
  markDocumentsSubmitted: (userId: string | null) => void;
  reset: () => void;
};

const initialState: MarketKycDocvState = {
  submittedForUserId: null,
};

export const MARKET_KYC_DOCV_STORAGE_KEY = 'market-kyc-docv';

export const useMarketKycDocvStore = create<MarketKycDocvState & MarketKycDocvActions>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        markDocumentsSubmitted: (userId) =>
          set({ submittedForUserId: userId }, false, 'markDocumentsSubmitted'),

        reset: () => set(initialState, false, 'reset'),
      }),
      {
        name: MARKET_KYC_DOCV_STORAGE_KEY,
        partialize: (state) => ({ submittedForUserId: state.submittedForUserId }),
      }
    ),
    { name: 'MarketKycDocvStore' }
  )
);

export const useHasSubmittedDocuments = (userId: string | null): boolean =>
  useMarketKycDocvStore((state) => !!userId && state.submittedForUserId === userId);

export const useMarkDocumentsSubmitted = (): ((userId: string | null) => void) =>
  useMarketKycDocvStore((state) => state.markDocumentsSubmitted);

export const useClearDocumentsSubmitted = (): (() => void) =>
  useMarketKycDocvStore((state) => state.reset);
